var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product container"},[_c('breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_vm._v(" "),_c('product-details',{attrs:{"product-heading":_vm.getPageHeading(),"product":this.product,"product-properties":_vm.productProperties,"db-config":_vm.dbConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }